import { render, staticRenderFns } from "./PricingPlan.vue?vue&type=template&id=b74c8636&"
import script from "./PricingPlan.vue?vue&type=script&lang=js&"
export * from "./PricingPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports